<div class="maintenance-page">
  <img class="logo" src="assets/images/pdq-logo.svg" alt="PrettyDamnQuick logo" />
  <div class="content">
    <h1>The site is currently down for maintenance</h1>
    <h2>We apologize for any inconveniences caused. we’re almost done.</h2>
  </div>
  <img class="illustration" src="assets/images/plugin-connectors.svg" alt="Maintenance in progress" />
</div>
